import { useRef, useState } from "react";
import { Table } from "./Table";
import { Form } from "./Form";
import { Toast } from "primereact/toast";
import { IPermissionProps } from "../../../models/Login";

export interface ITenderMast {
  id?: number | null;
  contact_Person_ID: number;
  title?: string | null;
  minBidAmnt?: string;
  description?: string | null;
  // tender_Doc_Path?: string | null;
  added_By?: string | null;
  added_By_ID?: number | null;

  // assignedTo?: number | null;
  added_On?: Date | null;
  // updated_By?: number | null;
  updated_On?: Date | null;
  tender_Published_Date?: Date | null;
  pre_Proposal_Meeting_Date?: Date | null;
  q_A_Date?: Date | null;
  due_Date?: Date | null;
  assigned_To?: string;
  assignedToId?: number;
  status?: string;
  client_Category?: number | null;
  service_Department?: number | null;
  vendor_Company?: number | null
  poc_Designation?: string | null;
  poc_Department?: string | null;
  client_Category_Name?: string | null;
  vendor_Company_Name?: string | null;
  service_Department_Name?: string | null;
  tender_Client?: string | null;
  rfP_Number:string;
}
export const EmptyTenderMast: ITenderMast = {
  id: null,
  contact_Person_ID: 0,
  title: "",
  description: "",
  // tender_Doc_Path: "",
  // added_By: null,
  added_On: null,
  // updated_By: null,
  updated_On: null,
  tender_Published_Date: null,
  pre_Proposal_Meeting_Date: null,
  q_A_Date: null,
  due_Date: null,
  assigned_To: "",
  assignedToId: 0,
  status: "",
  rfP_Number:""
};
export interface IModel {
  open: boolean;
  singleData: ITenderMast;
}

export const TenderMast = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyTenderMast, open: false } as IModel);
  const [reload, setReload] = useState<boolean>(false);
  const toast = useRef<any>();
  const hideDialog = () => {
    setModal({ singleData: EmptyTenderMast, open: false });
  };

  return (
    <>
      <Table permission={permissions} setModal={setModal} toast={toast} reload={reload} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};
